import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { MonitorGroup } from '../../models/monitor-group';
import { MonitorService } from '../../services/monitor.service';
import { GenericModalService, ModalSettingsInput, ModalMultiButton, ModalSettingsMessage } from '../../../shared/generic-modal/generic-modal.service';
import { SvgIconComponent } from '../../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { MonitorGroupsGridComponent } from '../monitor-groups-grid/monitor-groups-grid.component';

@Component({
    selector: 'app-monitor-groups',
    templateUrl: './monitor-groups.component.html',
    styleUrls: ['./monitor-groups.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, MonitorGroupsGridComponent]
})
export class MonitorGroupsComponent implements OnInit {
    monitorGroups: MonitorGroup[] = [];

    constructor(
        private loadingPanelService: LoadingPanelService,
        private monitorService: MonitorService,
        private genericModalService: GenericModalService) {
    }

    async ngOnInit(): Promise<void> {
        await this.refresh();
    }

    async refresh(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading monitor groups...');
            this.monitorGroups = await this.monitorService.getMonitorGroups();
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    async onSaveGroup(group: MonitorGroup): Promise<void> {
        const saved = await this.monitorService.saveMonitorGroup(group);
        group.id = saved.id;
        group.CreatedBy = saved.CreatedBy;
        group.CreatedDate = saved.CreatedDate;
        group.UpdatedBy = saved.UpdatedBy;
        group.UpdatedDate = saved.UpdatedDate;
    }

    async onDeleteGroup(group: MonitorGroup): Promise<number> {
        const items = await (await this.monitorService.getMonitorItems()).filter(x => x.monitorGroupId === group.id);
        if (items !== null && items.length > 0) {
            this.genericModalService.messageDirect('Error deleting', 'Cant delete group while items exist in the group.');
            this.refresh();
            return 0;
        }
        else {
            const rows = await this.monitorService.deleteMonitorGroup(group.id);
            return rows;
        }
    }
}
